import React from 'react';
import { formatDateTime12hIST } from '../utils/dateDisplay';
import {
  formatInr,
  maskPhone,
  transactionDisplayName
} from '../utils/transactionDisplay';

export function TransactionDetailSheet({ transaction, onClose }) {
  if (!transaction) return null;

  const name = transactionDisplayName(transaction);
  const phoneMasked = transaction.customerPhone ? maskPhone(transaction.customerPhone) : '';

  return (
    <div className="tx-sheet-backdrop" role="presentation" onClick={onClose}>
      <div
        className="tx-sheet"
        role="dialog"
        aria-modal="true"
        aria-labelledby="tx-sheet-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="tx-sheet-handle-wrap">
          <span className="tx-sheet-handle" />
        </div>
        <h2 id="tx-sheet-title" className="tx-sheet-title">
          Transaction details
        </h2>
        <dl className="tx-sheet-dl">
          <div>
            <dt>From</dt>
            <dd>{name}</dd>
          </div>
          {phoneMasked ? (
            <div>
              <dt>Phone</dt>
              <dd>{phoneMasked}</dd>
            </div>
          ) : null}
          <div>
            <dt>Amount</dt>
            <dd className="tx-sheet-amount">{formatInr(transaction.amount)}</dd>
          </div>
          <div>
            <dt>Type</dt>
            <dd>{transaction.tipType === 'pool' ? 'Pool' : 'Individual'}</dd>
          </div>
          {transaction.employeeName && transaction.employeeName !== 'Unknown' ? (
            <div>
              <dt>Employee</dt>
              <dd>{transaction.employeeName}</dd>
            </div>
          ) : null}
          <div>
            <dt>Date</dt>
            <dd>{formatDateTime12hIST(transaction.createdAt)}</dd>
          </div>
          <div>
            <dt>Transaction ID</dt>
            <dd className="tx-sheet-mono">{transaction.id}</dd>
          </div>
        </dl>
        <button type="button" className="btn btn-primary tx-sheet-close" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
}
